import type { User } from "firebase/auth"
import type React from "react"
import { useMemo } from "react"
import { memo } from "react"
import { twMerge } from "tailwind-merge"

type AvatarProps = {
  user: User
  size: "small" | "large" | number
  onEvent?(): void
}

const Avatar: React.FC<AvatarProps> = ({ user, size, onEvent = () => { } }) => {
  const RenderAvatar = useMemo(() => {
    const { photoURL, displayName, email } = user

    const sizeInitials = () => {
      if (typeof size === "number") {
        return "text-pn-headline-emphasis"
      }

      return size === "small" ? "text-pn-button-2" : "text-pn-headline-emphasis"
    }

    const returnInitials = () => {
      if (displayName) {
        if (displayName?.split(" ").length > 1) {
          const i_one = displayName.split(" ")[0].split("")[0]
          const i_two = displayName.split(" ")[1].split("")[0]

          return i_one + i_two
        } else {
          return displayName.split("")[0]
        }
      } else {
        if (email && email?.length > 0) {
          const splited_email = email?.split("")[0].toUpperCase()

          return splited_email
        }

        return ""
      }
    }

    return photoURL ? (
      <img
        src={photoURL}
        style={{
          borderRadius: "99px",
        }}
        loading="lazy"
        className={"w-full h-full object-cover"}
      />
    ) : (
      <div
        className={twMerge(
          sizeInitials(),
          "bg-[#F4E34E] w-full h-full flex items-center justify-center rounded-full",
        )}
      >
        {returnInitials()}
      </div>
    )
  }, [user, size])

  return (
    <button
      onClick={onEvent}
      style={{
        width: typeof size === "number" ? size + "px" : size === "small" ? "38px" : "56px",
        height: typeof size === "number" ? size + "px" : size === "small" ? "38px" : "56px",
      }}
      className={twMerge("rounded-full cursor-pointer")}
    >
      {RenderAvatar}
    </button>
  )
}
export default memo(Avatar)
